import React, { useEffect } from "react";
import Container from "../Container/Container";
import Project from "./Project/Project";
import "./ProjectsSection.css";

const ProjectsSection = () => {
    // fetch projects from json in public folder
    const [projects, setProjects] = React.useState<any>([]);

    useEffect(() => {
        fetch("/projects.json")
            .then((response) => response.json())
            .then((data) => setProjects(data.projects));
    }, []);

    return <Container>
        <section className="projects-section" id="projects">
            <div className="projects-header">
                <h1>Recent Projects</h1>
            </div>
            <div className="projects-container">
                {projects.map((project: any, index: number) => (
                    <Project key={index} name={project.name} description={project.description} skills={project.skills} image={project.image} link={project.link} slug={project.slug} slides={project.slides}/>
                ))}
            </div>
        </section>
    </Container>;
};

export default ProjectsSection;